import { MaskedRange } from 'imask';
import { DateRange } from '../../Calendar';
import { format, isValid } from 'date-fns';

const minYear = 2000;
const maxYear = 2099;

export const dateRangeMask = () => {
  return {
    mask: 'Y-m-d - Y-m-d',
    pattern: 'Y-m-d - Y-m-d',
    blocks: {
      d: {
        mask: MaskedRange,
        from: 1,
        to: 31,
        maxLength: 2,
      },
      m: {
        mask: MaskedRange,
        from: 1,
        to: 12,
        maxLength: 2,
      },
      Y: {
        mask: MaskedRange,
        from: minYear,
        to: maxYear,
      },
    },
    format: (date: DateRange | undefined) => {
      if (date && date.from) {
        const dateFrom = date.from && new Date(date.from);
        const dateTo = date.to && new Date(date.to);
        const formattedFrom = format(dateFrom, 'yyyy-MM-dd');
        const formattedTo = dateTo && format(dateTo, 'yyyy-MM-dd');
        return `${formattedFrom} - ${formattedTo}`;
      }

      return '';
    },
    parse: (str: string) => {
      const [fromDate, toDate] = str.split(' - ');
      const [fromDateYear, fromDateMonth, fromDateDay] = fromDate.split('-');
      const [toDateYear, toDateMonth, toDateDay] = toDate.split('-');

      const from = new Date(Number(fromDateYear), Number(fromDateMonth) - 1, Number(fromDateDay));
      const to = new Date(Number(toDateYear), Number(toDateMonth) - 1, Number(toDateDay));

      if (!isValid(from)) {
        return;
      }

      return {
        from,
        to: isValid(to) ? to : undefined,
      };
    },
    autofix: true,
    lazy: false,
  };
};
